export enum UserRole {
    CONSULTING_USER = 'consultingUser',
    BUSINESS_KEY_USER = 'businessKeyUser',
    BUSINESS_DIVERT_KEY_USER = 'businessDivertKeyUser',
    TECHNICAL_SUPPORT_USER = 'technicalSupportUser',
}

export interface UserPermissions {
    canAdjustQuantity: boolean;
    canViewEntryContext: boolean;
    canTriggerUKDivert: boolean;
    canTriggerDSLeftCW: boolean;
    canSimulateEvents: boolean;
    canViewPostGoLiveLogging: boolean;
    canViewFullLogging: boolean;
    canViewBasicView: boolean;
}
